module.exports = __webpack_public_path__ + "static/media/breakfast-brunch-tablet-738x57@2x.be6313f4.webp";